var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1464 10.8917C11.1189 10.8917 11.1005 10.8917 11.073 10.8917C11.0272 10.8825 10.963 10.8825 10.908 10.8917C8.24969 10.8092 6.24219 8.71915 6.24219 6.14332C6.24219 3.52165 8.37802 1.38582 10.9997 1.38582C13.6214 1.38582 15.7572 3.52165 15.7572 6.14332C15.748 8.71915 13.7314 10.8092 11.1739 10.8917C11.1647 10.8917 11.1555 10.8917 11.1464 10.8917ZM10.9997 2.76082C9.13885 2.76082 7.61719 4.28249 7.61719 6.14332C7.61719 7.97665 9.04719 9.45249 10.8714 9.51665C10.9172 9.50749 11.0455 9.50749 11.1647 9.51665C12.9614 9.43415 14.373 7.95832 14.3822 6.14332C14.3822 4.28249 12.8605 2.76082 10.9997 2.76082Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1555 20.9108C9.35881 20.9108 7.55298 20.4525 6.18714 19.5358C4.91298 18.6925 4.21631 17.5375 4.21631 16.2817C4.21631 15.0258 4.91298 13.8617 6.18714 13.0092C8.93714 11.185 13.3921 11.185 16.1238 13.0092C17.3888 13.8525 18.0946 15.0075 18.0946 16.2633C18.0946 17.5192 17.398 18.6833 16.1238 19.5358C14.7488 20.4525 12.9521 20.9108 11.1555 20.9108ZM6.94798 14.1642C6.06798 14.7508 5.59131 15.5025 5.59131 16.2908C5.59131 17.07 6.07714 17.8217 6.94798 18.3992C9.23047 19.93 13.0805 19.93 15.363 18.3992C16.243 17.8125 16.7196 17.0608 16.7196 16.2725C16.7196 15.4933 16.2338 14.7417 15.363 14.1642C13.0805 12.6425 9.23047 12.6425 6.94798 14.1642Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.10142d890acdec1d242498aec1567bd0.svg";
export { ForwardRef as ReactComponent };